import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/**
 * I-beam (text cursor) icon used by Semantic UI's `i cursor`.
 * The mapped MUI `Title` icon renders as a "T" shape, which reads as the
 * wrong glyph for the trends segment-mode toggle - that control marks a
 * vertical I-beam selection. This SVG draws an upright capital I with
 * serifs so the glyph matches its meaning.
 */
const IBeamIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function IBeamIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 24 24" {...props}>
      <path
        d="M8 4h8v2.4h-2.8v11.2H16V20H8v-2.4h2.8V6.4H8z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});

export default IBeamIcon;
